export default "__VITE_ASSET__B$MEE$t0__";